import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {User} from '../models/user';
import {Product} from '../models/product';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/gsb/products';

@Injectable()
export class ProductsService {
  constructor(private http: HttpClient) {
  }

  getAll(): Observable<any> {
    const url = `${apiUrl}`;
    return this.http.get<any>(url);
  }
  create(product: Product) {
    return this.http.post<User>(apiUrl , product, httpOptions);
  }

  delete(id: number) {
    const url = `${apiUrl}/${id}`;
    return this.http.delete<User>(url, httpOptions);
  }
}
